export const messagesFormPath = {
  parent: "chat-contacts",
  child: "messages",
  maxPage: "max-page-messages",
  currentPage: "current-page-messages",
  unreadCount: "unread-count-messages",
  createConversation: "create-conversation",
};
